import * as React from 'react';
import { Stack, Label, IconButton } from '@fluentui/react';

interface OnRenderRankLabelProps {
  onIconClick: () => void;
  disabled?: boolean
}

export const OnRenderRankLabel: React.FC<OnRenderRankLabelProps> = ({
  onIconClick,
  disabled = false
}) => (
  <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
    <Label styles={{ root: { margin: 0 } }} disabled={disabled}>Rank</Label>
    <IconButton
      iconProps={{ iconName: 'AddTo' }}
      title="Add Rank"
      ariaLabel="Add Rank"
      onClick={onIconClick}
      disabled={disabled}
      styles={{
        root: {
          width: 24,
          height: 24,
          padding: 0,
        },
        icon: {
          margin: 0,
        },
        flexContainer: {
          padding: 0,
          margin: 0,
        },
      }}
    />
  </Stack>
);
